import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const deleteAgentRecruitmentAppointment = createAsyncThunk("login/deleteAgentRecruitmentAppointment", async (data, thunkAPI) => {
  let { id, handleSuccessDelete, handleError } = data;
  try {
    const resp = await axios.delete(`${process.env.REACT_APP_BASE_URL}api/recruitment/appointments/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (handleSuccessDelete) {
      handleSuccessDelete();
    }
    return {...resp.data,id};
  } catch (error) {
    if (error.response) {
      if (handleError) {
        handleError(error.response.data.message);
      }
      return thunkAPI.rejectWithValue(error.response.data.message);
    } else {
      if (handleError) {
        handleError(error.message);
      }
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
